<template lang="">
  <div id="content">
    <div class="global_area">
      <div class="path"><a href="#none">Home</a> &gt; <a href="#none">공지사항 관리</a> &gt; <strong>공지사항 리스트</strong></div>
      <h2 class="h_sub">공지사항 등록 <span class="fs_regular">[보기&amp;수정]</span></h2>
    </div>

    <BoardNoticeCreateForm/>
  </div>
</template>

<script>
import BoardNoticeCreateForm from '@/components/admin/board/BoardNoticeCreateForm.vue';

export default {
  components: {
    BoardNoticeCreateForm
  }
    
}
</script>
<style lang="">
    
</style>